var pym = require("./lib/pym");
require("./lib/webfonts");
var { isMobile } = require("./lib/breakpoints");
var topojson = require("topojson/dist/topojson.min");
var co = require("./schooldistrict_sy1819_tl19_colorado.json");
var pymChild;
var { COLORS, classify } = require("./lib/helpers");

var d3 = {
  ...require("d3-geo/dist/d3-geo.min"),
  ...require("d3-fetch/dist/d3-fetch.min"),
  ...require("d3-selection/dist/d3-selection.min"),
  ...require("d3-scale/dist/d3-scale.min"),
  ...require("d3-array/dist/d3-array.min"),
};

var tooltip;

// var districtName = d3.select("#district-name");
// var fafsa19 = d3.select("#fafsa-19");
// var fafsa20 = d3.select("#fafsa-20");
// var fafsaChange = d3.select("#fafsa-change");
// var button19 = d3.select("#button-2019");
// var button20 = d3.select("#button-2020");
// var buttonChange = d3.select("#button-change");
// var key = d3.select("#key-bar");
// var keyChange = d3.select("#key-bar-change");
// var keyYearsContainer = d3.select("#key-years-container");
// var keyChangeContainer = d3.select("#key-change-container");

//Initialize graphic
var onWindowLoaded = function() {
  // var geodata = topojson.feature(co, co.objects["schooldistrict_sy1819_tl19_colorado"]).features;
  var geodata = topojson.feature(co, co.objects["collection"]).features;
  tooltip = document.getElementById("tooltip");
  render(geodata);
  window.addEventListener("resize", function() { render(geodata) });

  pym.then(child => {
    pymChild = child;
    child.sendHeight();
  });
};

var render = function(geodata) {

  var containerIn = "#graphic-in";
  var elementIn = document.querySelector(containerIn);
  var width = elementIn.offsetWidth;

  var containerOut = "#graphic-out";

  renderMap({
    container: containerIn,
    width,
    data: DATA,
    geodata,
    column: "age1",
    column2: "age2",
    column3: "age3",
    column4: "age4",
    column5: "age5",
    column6: "age6"
  });

  // renderMap({
  //   container: containerOut,
  //   width,
  //   data: DATA,
  //   geodata,
  //   column: "choice_out"
  // });

  // Update iframe
  if (pymChild) {
    pymChild.sendHeight();
  }

};


var renderMap = function(config) {

  var lookup = new Map();
  var lookup2 = new Map();
  var lookup3 = new Map();
  var lookup4 = new Map();
  var lookup5 = new Map();
  var lookup6 = new Map();
  config.data.forEach(function(d) {
    lookup.set(d.district, d[config.column]);
    lookup2.set(d.district, d[config.column2]);
    lookup3.set(d.district, d[config.column3]);
    lookup4.set(d.district, d[config.column4]);
    lookup5.set(d.district, d[config.column5]);
    lookup6.set(d.district, d[config.column6]);
  });

console.log(lookup)
  var values = config.data.map(d => d[config.column]);
  var min = 0
  var max = 1;
  // var max = d3.max(values);

  var colorScale = d3.scaleLinear()
    .range(["white", COLORS.teal1])
    .domain([min, max]);

  var containerElement = d3.select(config.container);
  containerElement.html("");

  var aspectWidth = isMobile.matches ? 4 : 16;
  var aspectHeight = isMobile.matches ? 3 : 12;
  var margins = { top: 10, right: 6, bottom: 6, left: 6 };

  // Calculate actual chart dimensions
  var chartWidth = (config.width - margins.left - margins.right);
  var chartHeight =
    Math.ceil((config.width * aspectHeight) / aspectWidth) -
    margins.top - margins.bottom+160;

  // D3 Projection
  var projection = d3.geoAlbersUsa()
    .fitExtent([[margins.left, margins.top], [chartWidth, chartHeight]],
      topojson.feature(co, co.objects["collection"]));
      // topojson.feature(co, co.objects["schooldistrict_sy1819_tl19_colorado"]));
      // co.objects["schooldistrict_sy1819_tl19_colorado"])
      // co.objects["collection"])
  // Define path generator
  var path = d3.geoPath().projection(projection);

  var chartWrapper = containerElement
   .append("div")
   .attr("class", "graphic-wrapper");

  var chartElement = chartWrapper
   .append("svg")
   .attr("width", chartWidth + margins.left + margins.right)
   .attr("height", chartHeight + margins.top + margins.bottom)
   .append("g")
   .attr("transform", `translate(${margins.left},${margins.top})`);

   var mapGroup = chartElement
    .append("g")
    .attr("class", "map")
    .attr("transform", `translate(0,${margins.top+15})`);

   var districts = mapGroup
    .selectAll("path")
    .data(config.geodata)
    .enter()
    .append("path")
    .attr("class", d => classify(d.properties.NAME) + "-district map")
    .attr("fill", function (d) {
      if (lookup.get(d.properties.NAME)){
        return colorScale(lookup.get(d.properties.NAME))
      }
      else {
        return "#F3EEDD"
      }
    })
    .attr("stroke", "#fff")
    .attr("d", path);

  districts.on("mouseenter", function(d) {
    console.log(tooltip);
    districts.attr("stroke", "#fff");
    districts.attr("stroke-width", 1);
    var highlight = d3.select(this);
    highlight.raise();
    highlight.attr("stroke", COLORS.gray1);
    highlight.attr("stroke-width", 2);
    tooltip.style.visibility = "visible";
  });

  districts.on("mousemove", function(d){
    var x = event.clientX;
    var y = event.clientY;
    var tooltipHeight = tooltip.offsetHeight;
    tooltip.style.left = x < config.width/2 ? x + 5  + "px": x - (tooltip.offsetWidth + 5) + "px";
    tooltip.style.top = y - tooltipHeight + "px";
    tooltip.innerHTML = `Zip: ${d.properties.NAME}  <br/> <br/>12-17:  <strong><i>${(Math.round(lookup.get(d.properties.NAME)*10000))/100 + "%"}</i></strong> <br/> 18-29: <i>${(Math.round(lookup2.get(d.properties.NAME)*10000))/100 + "%"}</i> <br/> 30-49: <i>${(Math.round(lookup3.get(d.properties.NAME)*10000))/100 + "%"}</i> <br/> 50-64: <i>${(Math.round(lookup4.get(d.properties.NAME)*10000))/100 + "%"} </i><br/>  65-79: <i>${(Math.round(lookup5.get(d.properties.NAME)*10000))/100 + "%"} </i><br/> 80+: <i>${(Math.round(lookup6.get(d.properties.NAME)*10000))/100 + "%"}</i> <br/>`
    tooltip.innerHTML = `Zip: ${d.properties.NAME}  <br/> <br/> <strong><i>${(Math.round(lookup.get(d.properties.NAME)*10000))/100 + "%"}</i></strong>  <i>Vaccinated</i>`
    
    // if (lookup.get(d.properties.NAME) < 0){
    //   tooltip.innerHTML = `${d.properties.NAME} <br/> - ${(Math.round(lookup.get(d.properties.NAME)*10000))/100*-1 + "% from FY 20-21"}`
    // }
    // else if (lookup.get(d.properties.NAME) > 0){
    //   tooltip.innerHTML = `${d.properties.NAME} <br/> + ${(Math.round(lookup.get(d.properties.NAME)*10000))/100 + "% from FY 20-21"}`
    // }
    // else {
    //   tooltip.innerHTML = `${d.properties.NAME} <br/> ${(Math.round(lookup.get(d.properties.NAME)*10000))/100 + "% from FY 20-21"}`
    
    // }
    // tooltip.innerHTML = lookup.get(d.properties.NAME) ?  : `${d.properties.NAME}: No data`;
  });

  districts.on("mouseout", function(d) {
    tooltip.style.visibility = "hidden";
    var highlight = d3.select(this);
    highlight.attr("stroke", "#fff");
    highlight.attr("stroke-width", 1);
  });



  var w = 120, h = 12;

    var key = chartElement
      .append("g")
      .attr("width", w)
      .attr("height", h)
      .attr("transform", isMobile.matches ? "translate("+ (chartWidth*0.5-w*.5) +","+(-margins.top)+")" : "translate("+ (chartWidth*0.5-w*.5) +","+(-margins.top)+")");
;

chartElement.append("text")
.attr("font-family", "'Barlow Condensed', 'Helvetica', 'Arial', sans-serif")
.attr("font-size", ".72em")
.text("0% Vaccinated")
.attr("transform", isMobile.matches ? "translate("+ (chartWidth*.25) +","+(-margins.top+40)+")" : "translate("+ (chartWidth*.28) +","+(-margins.top+40)+")");

chartElement.append("text")
.attr("font-family", "'Barlow Condensed', 'Helvetica', 'Arial', sans-serif")
.attr("font-size", ".72em")
.text("100% Vaccinated")
.attr("transform", isMobile.matches ? "translate("+ (chartWidth*.57) +","+(-margins.top+40)+")" : "translate("+ (chartWidth*.57) +","+(-margins.top+40)+")");


  var legend = key.append("defs")
  .append("svg:linearGradient")
  .attr("id", "gradient")
  .attr("x1", "0%")
  .attr("y1", "100%")
  .attr("x2", "100%")
  .attr("y2", "100%")
  .attr("spreadMethod", "pad");

legend.append("stop")
  .attr("offset", "0%")
  .attr("stop-color", "rgb(255, 255, 255)")
  .attr("stop-opacity", 1);

  // legend.append("stop")
  // .attr("offset", "50%")
  // .attr("stop-color", "#F3EEDD")
  // .attr("stop-opacity", 1);


legend.append("stop")
  .attr("offset", "100%")
  .attr("stop-color", "rgb(0, 87, 101)")
  .attr("stop-opacity", 1);

key.append("rect")
  .attr("width", w)
  .attr("height", h)
  .style("fill", "url(#gradient)")
  .attr("transform", "translate(0,10)");


};

  // var keyWidth = document.querySelector(".key-bar").offsetWidth;
  // var keyHeight = document.querySelector(".key-bar").offsetHeight;
  //
  // var keyBar = key.selectAll("rect")
  //   .data(keySteps)
  //   .enter()
  //   .append("rect")
  //   .attr("width",keyWidth/keySteps.length)
  //   .attr("height",keyHeight)
  //   .attr("x", function(d,i) {
  //     return keyWidth/keySteps.length*i;
  //   })
  //   .attr("y",0)
  //   .attr("class","key-steps")
  //   .style("fill",d => colorScale(d));
  //
  // var keyBarChange = keyChange.selectAll("rect")
  //   .data(keyStepsChange)
  //   .enter()
  //   .append("rect")
  //   .attr("width",keyWidth/keyStepsChange.length)
  //   .attr("height",keyHeight)
  //   .attr("x", function(d,i) {
  //     return keyWidth/keyStepsChange.length*i;
  //   })
  //   .attr("y",0)
  //   .attr("class","key-steps")
  //   .style("fill",d => colorScaleChange(d));

  // d3.json("./"+ fileName +".json").then(function(districts) {
  //     paths.on("mouseenter",function(d){
  //       var changeLow = Math.abs(d.properties.FAFSA_2020_Low-d.properties.FAFSA_2019_High);
  //       var changeHigh = Math.abs(d.properties.FAFSA_2020_High-d.properties.FAFSA_2019_Low);
  //       var lowHigh = d.properties.FAFSA_2020_Low-d.properties.FAFSA_2019_High > 0 ? "higher" : "lower";
  //       paths.style("opacity",0.6);
  //       d3.select(this).style("opacity",1);
  //       districtName.html(d.properties.NAME);
  //       fafsa19.html(d.properties.FAFSA_2019 ? d.properties.FAFSA_2019+"%" : "Missing/Insufficient Data");
  //       fafsa20.html(d.properties.FAFSA_2019 ? d.properties.FAFSA_2020+"%" : "Missing/Insufficient Data");
  //       if (changeLow > changeHigh) {
  //         fafsaChange.html(changeHigh + "-" + changeLow + " percentage points " + lowHigh);
  //       } else if (changeLow < changeHigh) {
  //         fafsaChange.html(changeLow + "-" + changeHigh + " percentage points " + lowHigh);
  //       } else if (changeLow = changeHigh) {
  //         fafsaChange.html("0-4 percentage points " + lowHigh);
  //       } else {
  //         fafsaChange.html("Missing/Insufficient Data");
  //       }
  //     });
  //
  //     paths.on("mouseout",function(d){
  //       paths.style("opacity",1);
  //       districtName.html("Statewide Average");
  //       fafsa19.html("50-54%");
  //       fafsa20.html("45-49%");
  //       fafsaChange.html("1-9 percentage points lower");
  //     });
  //
  //     button19.on("click",function(){
  //       keyYearsContainer.classed('active', true);
  //       keyChangeContainer.classed('active', false);
  //       button19.classed('active', true);
  //       button20.classed('active', false);
  //       buttonChange.classed('active', false);
  //       paths
  //         .style("fill", d => d.properties.FAFSA_2019_Low == null ? "#fff" : colorScale(d.properties.FAFSA_2019_Low))
  //         .style("stroke", d => d.properties.FAFSA_2019_Low == null ? "#fff" : colorScale(d.properties.FAFSA_2019_Low));
  //     });
  //
  //     button20.on("click",function(){
  //       keyYearsContainer.classed('active', true);
  //       keyChangeContainer.classed('active', false);
  //       button19.classed('active', false);
  //       button20.classed('active', true);
  //       buttonChange.classed('active', false);
  //       paths
  //         .style("fill", d => d.properties.FAFSA_2020_Low == null ? "#fff" : colorScale(d.properties.FAFSA_2020_Low))
  //         .style("stroke", d => d.properties.FAFSA_2020_Low == null ? "#fff" : colorScale(d.properties.FAFSA_2020_Low));
  //     });
  //
  //     buttonChange.on("click",function(){
  //       keyYearsContainer.classed('active', false);
  //       keyChangeContainer.classed('active', true);
  //       button19.classed('active', false);
  //       button20.classed('active', false);
  //       buttonChange.classed('active', true);
  //       paths
  //         .style("fill", d => d.properties.FAFSA_2020_Low == null | d.properties.FAFSA_2019_Low == null ? "#fff" : colorScaleChange(d.properties.FAFSA_2020_Low-d.properties.FAFSA_2019_Low))
  //         .style("stroke", d => d.properties.FAFSA_2020_Low == null | d.properties.FAFSA_2019_Low == null ? "#fff" : colorScaleChange(d.properties.FAFSA_2020_Low-d.properties.FAFSA_2019_Low));
  //     });
  //
  // });

//Initially load the graphic
// (NB: Use window.load to ensure all images have loaded)
window.onload = onWindowLoaded;
